import { filtersHelper } from '@/utils';
import { countryModel } from '@/models/api/country.model';
import { locationModel } from '@/models/api/location.model';

export const stateModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    country: data.country ? countryModel(data.country) : null,
    locations: (data.locations ?? []).map(item => (locationModel(item))),
});